import { render, staticRenderFns } from "./WidgetEditor.vue?vue&type=template&id=5531daf7&"
import script from "./WidgetEditor.vue?vue&type=script&lang=js&"
export * from "./WidgetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports